import axios from "axios";
import {getBaseUrl} from "../config";

const mute = (participantId, sessionId) => {
    const baseUrl = getBaseUrl();
    return axios.post(`${baseUrl}/services/visio/mute/${sessionId}/${participantId}`);
};

export { mute };